import { Link, useNavigate } from 'react-router-dom'
import { api } from '../api/client'
import { useAsync } from '../lib/useAsync'
import { durationFromMinutes, journalTime, number } from '../lib/format'
import { Avatar, BarList, CardSkeleton, ErrorState, PageHeader, Section, StatTile } from '../components/ui'
import './Overview.css'

/** Screen 7a · Admin · İcmal. */
export function Overview() {
  const navigate = useNavigate()
  const { data, error, loading, reload } = useAsync(() => api.overview(), [])

  if (error) return <ErrorState error={error} onRetry={reload} />

  if (loading || !data) {
    return (
      <>
        <PageHeader title="Yüklənir…" />
        <div className="grid overview__tiles">
          {[0, 1, 2, 3].map((i) => (
            <CardSkeleton key={i} height={112} />
          ))}
        </div>
        <CardSkeleton height={280} />
      </>
    )
  }

  return (
    <>
      <PageHeader
        title={`Salam, ${data.greetingName}`}
        subtitle={
          <>
            Bugün <strong className="numeral">{number(data.pendingReports)}</strong> şikayət
            gözləyir · orta cavab vaxtı {durationFromMinutes(data.avgResponseMinutes)}
          </>
        }
        actions={
          <button
            type="button"
            className="btn btn--primary"
            onClick={() => void navigate('/novbe')}
          >
            Növbəyə keç
          </button>
        }
      />

      <div className="grid overview__tiles">
        <StatTile
          label="Gözləyən şikayət"
          value={data.pendingReports}
          hint={
            data.urgentReports > 0 ? `${number(data.urgentReports)} təcili` : 'təcili yoxdur'
          }
          tone={data.urgentReports > 0 ? 'urgent' : 'default'}
        />
        <StatTile label="Bu həftə baxılan" value={data.reviewedThisWeek} hint="son 7 gün" />
        <StatTile
          label="Aktiv moderator"
          value={data.activeModerators}
          hint={
            data.suspendedModerators > 0
              ? `${number(data.suspendedModerators)} dayandırılmış`
              : 'hamısı aktiv'
          }
        />
        <StatTile label="Yeni müraciət" value={data.newApplications} hint="baxılmamış" />
      </div>

      <div className="overview__split">
        <Section
          title="Son moderator fəaliyyəti"
          actions={
            <Link className="btn btn--ghost btn--sm" to="/jurnal">
              Hamısı
            </Link>
          }
        >
          {data.recentActivity.length === 0 ? (
            <p className="muted">Hələ qeyd yoxdur.</p>
          ) : (
            <ul className="activity">
              {data.recentActivity.map((row) => (
                <li key={row.id} className="activity__item">
                  <Avatar initials={row.actorInitials} title={`@${row.actorUsername}`} />
                  <div className="activity__text">
                    <div>
                      {row.action} · <span className="activity__ref">{row.objectRef}</span>
                    </div>
                    <div className="activity__time muted">{journalTime(row.createdAt)}</div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </Section>

        <div className="stack">
          <section
            className={`card queue-health queue-health--${data.queueHealthy ? 'ok' : 'warn'}`}
          >
            <h3>{data.queueHealthy ? 'Növbə sağlamdır' : 'Növbə gecikir'}</h3>
            <p className="muted">
              {data.oldestPendingHours === undefined || data.oldestPendingHours === null
                ? 'Gözləyən şikayət yoxdur.'
                : data.queueHealthy
                  ? '24 saatdan köhnə şikayət yoxdur.'
                  : `Ən köhnə şikayət ${Math.round(data.oldestPendingHours)} saatdır gözləyir.`}
            </p>
            {data.openAppeals > 0 && (
              <p className="muted">
                <span className="numeral">{number(data.openAppeals)}</span> etiraz baxılmayıb.
              </p>
            )}
          </section>

          <Section title="Şikayət növləri · 7 gün">
            {data.reasonBreakdown.length === 0 ? (
              <p className="muted">Son 7 gündə şikayət olmayıb.</p>
            ) : (
              <BarList
                items={data.reasonBreakdown.map((r) => ({
                  label: r.label,
                  value: r.total,
                  // The two reasons the handoff marks urgent.
                  tone: r.reason === 'ABUSE' || r.reason === 'PERSONAL_INFO' ? 'urgent' : 'default',
                }))}
              />
            )}
          </Section>
        </div>
      </div>
    </>
  )
}
